module.exports = __webpack_public_path__ + "static/media/skip-1.e33d03fa.jpeg";